import type { TemplateConfig } from "./configType";
import templateConfig from "./templateConfig";

/** Config landing avec chemins absolus selon `import.meta.env.BASE_URL` (Vite). */
export function getResolvedTemplateConfig(): TemplateConfig {
  const logoBase = import.meta.env.BASE_URL.replace(/\/?$/, "/");
  const envPlay = String(import.meta.env.VITE_GOOGLE_PLAY_URL ?? "").trim();
  const envAppStore = String(import.meta.env.VITE_APP_STORE_URL ?? "").trim();

  const resolvePublicAsset = (src: string) =>
    /^https?:\/\//i.test(src) ? src : `${logoBase}${String(src).replace(/^\//, "")}`;

  const home =
    templateConfig.home && templateConfig.home.howItWorks
      ? {
          ...templateConfig.home,
          howItWorks: {
            ...templateConfig.home.howItWorks,
            steps: templateConfig.home.howItWorks.steps.map((step) => ({
              ...step,
              image: resolvePublicAsset(step.image),
            })),
          },
        }
      : templateConfig.home;

  return {
    ...templateConfig,
    home,
    logo: `${logoBase}agbaza-logo-180x180.png`,
    ogImage: templateConfig.ogImage
      ? `${logoBase}${String(templateConfig.ogImage).replace(/^\//, "")}`
      : undefined,
    googlePlayLink: envPlay || templateConfig.googlePlayLink,
    appStoreLink: envAppStore || templateConfig.appStoreLink,
  };
}
